<div class="branch-select-field" (click)="$event.stopPropagation()">
  <button
    type="button"
    class="branch-select-field__trigger"
    (click)="toggleMenu($event)"
    [attr.aria-expanded]="isMenuOpen"
    [attr.aria-haspopup]="true"
  >
    <span class="branch-select-field__label">{{
      'BRANCH_SELECT_FIELD.LABEL' | translate
    }}</span>

    <span class="branch-select-field__icon-wrap" aria-hidden="true">
      <img
        class="branch-select-field__isotipo"
        src="./assets/img/isotipo.svg"
        alt=""
        width="24"
        height="24"
      />
    </span>

    <span class="branch-select-field__value">{{ displayLabel }}</span>

    <mat-icon
      class="branch-select-field__chevron"
      [class.branch-select-field__chevron--open]="isMenuOpen"
      svgIcon="keyboard_arrow_down"
      aria-hidden="true"
    ></mat-icon>
  </button>

  @if (isMenuOpen) {
    <div class="branch-select-field__menu" role="listbox">
      @for (group of groupedBranches; track group.city) {
        <div class="branch-select-field__group">
          @for (branchItem of group.branches; track branchItem.id) {
            <button
              type="button"
              class="branch-select-field__option"
              role="option"
              [class.branch-select-field__option--selected]="
                isSelected(branchItem)
              "
              [attr.aria-selected]="isSelected(branchItem)"
              (click)="selectBranch(branchItem, $event)"
            >
              {{ branchItem.name }} -
              {{ branchItem.address.city || branchItem.address.locality }}
            </button>
          }
        </div>
      }
    </div>
  }
</div>
